import * as Yup from "yup";

import { createForm } from "../../../forms";

import type { TypeSafeReactLocalization } from "../../../../composites";

export type AddOrEditTemplateFormFields = {
  wireRecipientId: API.WireRecipientId;
  name: string;
  sourceAccountId: API.AccountId;
  wireReason?: string;
  amount?: Cents;
  memo?: string;
};

const translateValidationSchema = ({
  getString,
}: TypeSafeReactLocalization) => {
  const required = getString("form-generic-validation-required");
  return Yup.object().shape({
    wireRecipientId: Yup.string().required(required),
    name: Yup.string().required(required),
    sourceAccountId: Yup.string().required(required),
    wireReason: Yup.string(),
    amount: Yup.number().integer(getString("form-generic-validation-number")),
    memo: Yup.string()
      .min(1)
      .max(
        140,
        getString("form-generic-validation-limit-characters", { count: 140 }),
      ),
  });
};

const initialValues: AddOrEditTemplateFormFields = {
  wireRecipientId: "" as API.WireRecipientId,
  name: "",
  sourceAccountId: "" as API.AccountId,
  wireReason: undefined,
  amount: undefined,
  memo: undefined,
};

export const transformApiTemplateToForm = ({
  recipient: wireRecipientId,
  source_account: sourceAccountId,
  name,
  amount,
  wire_reason: wireReason,
  memo,
}: API.FedwireTemplate): AddOrEditTemplateFormFields => {
  return {
    wireRecipientId,
    sourceAccountId,
    name,
    amount: amount || undefined,
    wireReason: wireReason || undefined,
    memo: memo || undefined,
  };
};

export const upsertTemplateForm = createForm({
  initialValues,
  translateValidationSchema,
});
